/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { format } from 'date-fns';
import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';
import DepartamentosService from '../../../../services/departamentos';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import DatePicker from '../../../../components/DatePicker';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import { Container } from './styles';
import { FormWrapper, LinkModal, ModalContent } from '../../styles';

interface CreateOrderByValueModalProps {
  show: boolean;
  title: string;
  type: string;
  async?: boolean;
  handleClose(): void;
  handleAdd(data: any): void;
}

const schema = yup.object().shape({
  start_date: yup.string().required('Data inicial Obrigatória'),
  end_date: yup.string().required('Data final Obrigatória'),
  sorting: yup.string().required('Ordenação é obrigatório'),
});

const sortingOptions = [
  { value: 'F', label: 'Funcionário' },
  { value: 'C', label: 'Cartão' },
  { value: 'M', label: 'Matricula' },
];

const CreateOrderByValueModalAsync: React.FC<CreateOrderByValueModalProps> = ({
  handleClose,
  handleAdd,
  show,
  type,
  title,
  async,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const services = { DepartamentosService: new DepartamentosService() };
  const [loading, setLoading] = useState<boolean>(false);
  const [departamentos, setDepartamentos] = useState<any>([]);
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const { push } = useHistory();

  const handleGetDepartamentos = useCallback(async () => {
    try {
      const response = await services.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formTableRef.current?.setErrors({});

      const filterData = {
        ...data,
        'file-type': type,
        end_date: data.end_date ? format(data.end_date, 'dd/MM/yyyy') : '',
        start_date: data.start_date
          ? format(data.start_date, 'dd/MM/yyyy')
          : '',
      };

      await schema.validate(filterData, {
        abortEarly: false,
      });

      setLoading(true);
      await handleAdd(filterData);
      setLoading(false);
      handleClose();
      setModalRelatorio(true);
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        const errors = getValidationErrors(err);
        formTableRef.current?.setErrors(errors);
      }
      setLoading(false);
    }
  }, []);

  function relatorio() {
    push('/agendado');
  }

  const departamentosOptions = useMemo(() => {
    const options = departamentos.map((dep: any) => {
      return { value: dep.CodigoDepartamento, label: dep.Nome };
    });

    return options;
  }, [departamentos]);

  useEffect(() => {
    handleGetDepartamentos();
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <Form ref={formTableRef} onSubmit={handleSubmit}>
            {async && (
              <p className="async-text">
                O relatório será agendado e poderá ser encontrado no menu de
                Relatórios Agendados.
              </p>
            )}
            <Input
              name="code_order_recharge"
              label="Código do pedido (opcional)"
              placeholder="Digite o código do pedido"
            />
            <DatePicker
              name="start_date"
              label="De"
              placeholder="Digite a data"
            />
            <DatePicker
              name="end_date"
              label="Até"
              placeholder="Digite a data"
            />
            <Select
              name="employee_code"
              label="Departamento (Opcional)"
              placeholder="Selecione o departamento"
              schema={schema}
              options={departamentosOptions}
            />
            <Select
              name="sorting"
              label="Ordenação"
              placeholder="Ordenação"
              defaultValue={sortingOptions[0]}
              options={sortingOptions}
            />
            <div className="buttonsContainer">
              <Button color="orange" padding="1" type="submit">
                Gerar Relatório
              </Button>
            </div>
          </Form>
        )}
      </Modal>
      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <FormWrapper>
              <p>Estamos processando os dados do pedido do Relatório.</p>
              <p>
                <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                solicitado. Quando este processo for finalizado basta fazer o
                download do arquivo.
              </p>
            </FormWrapper>
          </ModalContent>
        </Modal>
      )}
    </Container>
  );
};

export default CreateOrderByValueModalAsync;
